import * as THREE from 'three'
import { MathUtils } from 'three'
import { Suspense, useEffect, useRef, useState } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls, ContactShadows } from '@react-three/drei'
import * as Tone from 'tone'
import inst from "./inst"
import { Instances, Instance } from '@react-three/drei'
import anime from 'animejs/lib/anime.es.js';

let hit = 0;
let getInst = () => {
  hit++;
  return (hit % 2 === 0) ? inst.synthL : inst.synthR
}
let lerp = MathUtils.lerp


let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]
let notes = ["C", "D", 'E']
let octaves = [2, 3,4]
let durs = [0.1, 0.2, 0.4, 0.6, 0.7,]
let octaveOffset = 0;

function Sequence({ updated, length, ready, index, y = 4000, space = 1, width = 0.07, height = 0.05,...props }) {
  const ref = useRef()
  const ref2 = useRef()
  let time = 0;
  let dur = 0
  let durMult = getRand([0.1, 0.25,0.1, 0.25,0.1, 0.25, 2,4])
  
  let data = Array.from({ length }, (v, i) => {
    let note = getRand(notes) + getRand(octaves);
    let midi = Tone.Frequency(note).toMidi()
    let pos = {
      x: i * 1.75 * width * space + (dur * 0.5),
      y: (midi * 0.0015) - 0.01,
      z: 0
    }
    dur = getRand(durs) * durMult;
    time += dur
    let velocity = dur - (Math.random() * dur * 2) + 0.3
    let scale = 1
    return { time, note, i, pos, dur, currPos: { x: 0, y: 0, z: 0 }, velocity, scale, midi, currScale: 1, durMult }
  });
  let loopEnd = time + dur
  const part = new Tone.Part(((time, val) => {
    let s = getInst();
    s.triggerAttackRelease(val.note[0] + (octaveOffset + parseInt(val.note[1])), val.dur * 4, time, val.velocity);
    data[val.i].scale = (1 + val.velocity)
    anime({
      targets: data[val.i],
      scale: 1,
      duration: loopEnd * 2000
    })
    let chance = 1 - (length * 0.02 * loopEnd)
    if (!val.i && (Math.random() > chance)) {
      octaveOffset = getRand([0, 1, 2])
    }
  }), data);

  useEffect(() => {
    if (ready) {
      part.start();
    }
    return () => part.stop()
  }, [ready, updated])
  part.loop = true;
  part.loopStart = 0;
  part.loopEnd = loopEnd;
  useFrame((state) => {
   ref.current.rotation.set(0,0,Math.PI * mut.rot)
   ref2.current.rotation.set(0,0, Math.PI + ((mut.rot + mut.rot2)*Math.PI))
  })
  let sphere = new THREE.SphereBufferGeometry(width*0.7, 32,32)
  let box = new THREE.BoxBufferGeometry(width*0.4, width*1.6,width*0.1)
  let box2 = new THREE.BoxBufferGeometry(width*2, width*0.6,width*0.2)
  let cone = new THREE.ConeBufferGeometry(width*0.5, width*1.5,32,32)
  let torus = new THREE.TorusBufferGeometry(width*0.5, width* 0.2,32,32)
  let octa = new THREE.OctahedronBufferGeometry(width*0.5)

  let speed1 = 0.01 + Math.random()*0.05
  let speed2 = 0.01 + Math.random()*0.05
  console.log(speed1,speed2)
  let base = '#222'
  let red = '#111'
  return (
    <>
      <Instances ref={ref} {...props} limit={1000} position={[0, 0, 0]} geometry={getRand([sphere, octa])}>
        <meshStandardMaterial roughness={0} color={getRand([base, base, base, red])} />
        {data.map((curr, i) => (
          <>
            <Note key={1} i={i} data={data} size={0.1} space={0} speed={speed1} />
            <Note key={2} i={i} data={data} size={0.2} space={1} speed={speed1} />
            <Note key={3} i={i} data={data} size={0.15} space={2} speed={speed1} />
            <Note key={4} i={i} data={data} size={0.12} space={3} speed={speed1} />
          </>
        ))}
      </Instances>
      <Instances ref={ref2} {...props} limit={1000}  position={[0, 0, 0]} geometry={getRand([box,box2,cone, torus, octa])}>
        <meshStandardMaterial roughness={0} color={getRand([base, base, red])} />
        {data.map((curr, i) => (
          <>
            <Note key={5} i={i} data={data} size={0.2} space={5} speed={speed2} />
          </>
        ))}
      </Instances>
    </>
  )
}


function Note({ i, size, space, data, speed}) {
  const ref = useRef()
  const ref2 = useRef()
  const ref3 = useRef()
  const ref4 = useRef()
  useFrame((state) => {
    let lerpScale = lerp(
      data[i].currScale,
      (data[i].scale - data[i].pos.y * (octaveOffset - (data[i].durMult * 5)) - (i * 0.05))
      , speed
    ) * mut.zoom
    data[i].currScale = lerpScale;
    let lerpX = lerp(data[i].currPos.x, data[i].pos.x * (1.2 + octaveOffset)*0.2, 0.02) * mut.zoom
    data[i].currPos.x = lerpX;
    ref.current.scale.setScalar(lerpScale * size)
    ref2.current.scale.setScalar(lerpScale * size)
    ref3.current.scale.setScalar(lerpScale * size)
    ref4.current.scale.setScalar(lerpScale * size)

    let col = [0, 0, data[0].scale * 0.5]
    ref.current.color.setHSL(...col)
    let y = mut.zoom * data[i].pos.y / lerpScale
    ref.current.position.set(lerpX, y * space, data[i].pos.z)
    ref2.current.position.set(lerpX, -y * space, data[i].pos.z)
    ref3.current.position.set(-lerpX, y * space, data[i].pos.z)
    ref4.current.position.set(-lerpX, -y * space, data[i].pos.z)
  })
  return (
    <>
      <Instance ref={ref} />
      <Instance ref={ref2} rotation={[0,0,Math.PI]} />
      <Instance ref={ref3} />
      <Instance ref={ref4} rotation={[0,0,Math.PI]}  />
    </>
  )
}
let canSpawn = true;
let mut = { zoom: 1, rot: 0, rot2:0 };
let easing = 'easeInQuart'
let easing2 = 'easeOutQuart'
let easing3 = 'easeInOutQuart'
let duration = 400
let first = false
export default function App() {

  const [ready, set] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [length, setLength] = useState(10)
  const click = () => {
    Tone.Transport.start();
    Tone.context.resume();
    
    if(!first){
      duration = 400
      first = true
    }
    if (canSpawn) {
      anime({
        targets: mut,
        zoom: 0,
        duration,
        easing,
        complete: function (anim) {
          setLength(Math.floor(Math.random() * Math.floor(Math.random() * (6)) + 3) + 3)
          setUpdated(!updated)
          set(true)
          canSpawn = false
          anime({
            targets: mut,
            zoom: 1,
            duration,
            easing: easing2,
          })
        }
      })
      let val = 5000;
      let time = (duration*2)/1000;
      inst.filterL.frequency.rampTo(val,time*0.5);
      inst.filterR.frequency.rampTo(val,time*0.5)
      setTimeout(() => {
        inst.filterL.frequency.rampTo(inst.defaultFreq,time);
        inst.filterR.frequency.rampTo(inst.defaultFreq,time)
        
      }, time*1000)
      anime({
        targets: mut,
        rot: mut.rot + getRand([0.5,0.125, 0,1]) * getRand([1,-1]),
        duration: duration*4,
        easing:easing3,
        complete: function (anim) {
          canSpawn = true
        }
      })
      anime({
        targets: mut,
        rot2: mut.rot2 + getRand([0.5,1]) * getRand([1,-1]),
        duration: duration*4,
        easing: easing3,
      })

    }
  }
  return (
    <div className="fullscreen" onMouseDown={() => {click()}}>
      <Canvas shadows dpr={[1, 2]} camera={{ position: [0, 0, 2], fov: 50 }}>
        <OrbitControls />
        <color attach="background" args={['#ffffff']} />
        <fog attach="fog" args={['red', 60, 110]} />
        <ambientLight intensity={1.5} />
        <pointLight position={[100, 10, -50]} intensity={20} castShadow />
        <Sequence updated={updated} index={1} ready={ready} length={length} />
      </Canvas>
    </div>
  )
}

console.log('%c🌱🌱 @ramioso 2021-10-05 🌱🌱 ', 'color: orange');